import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationManagerComponent } from './translation-manager/translation-manager.component';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import {RippleModule} from 'primeng/ripple';
import {TooltipModule} from 'primeng/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {ComponentsModule as AdminComponentsModule} from '../../../components/components.module';



@NgModule({
  declarations: [TranslationManagerComponent],
    imports: [
        CommonModule,
        ButtonModule,
        TableModule,
        DialogModule,
        InputTextModule,
        FormsModule,
        RippleModule,
        TooltipModule,
        TranslateModule,
        AdminComponentsModule
    ],
  exports: [TranslationManagerComponent]
})
export class ComponentsModule { }
